import { defineComponent, createBlock, openBlock, unref, mergeProps, withCtx, renderSlot } from "vue";
import { useForwardPropsEmits } from "../../../../node_modules/.pnpm/reka-ui@2.5.1_patch_hash_1a_fe91be2ae044c59728f130150abaf78d/node_modules/reka-ui/dist/shared/useForwardPropsEmits.js";
import { TooltipRoot_default } from "../../../../node_modules/.pnpm/reka-ui@2.5.1_patch_hash_1a_fe91be2ae044c59728f130150abaf78d/node_modules/reka-ui/dist/Tooltip/TooltipRoot.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Tooltip",
  props: {
    defaultOpen: { type: Boolean },
    open: { type: Boolean },
    delayDuration: {},
    disableHoverableContent: { type: Boolean },
    disableClosingTrigger: { type: Boolean },
    disabled: { type: Boolean },
    ignoreNonKeyboardFocus: { type: Boolean }
  },
  emits: ["update:open"],
  setup(__props, { emit: __emit }) {
    const forwarded = useForwardPropsEmits(__props, __emit);
    return (_ctx, _cache) => (openBlock(), createBlock(unref(TooltipRoot_default), mergeProps({
      "ignore-non-keyboard-focus": "",
      "data-slot": "tooltip"
    }, unref(forwarded)), {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Tooltip.vue.js.map
